<template>
  <div
    class="fts-automation-block-number"
    :title="`Block ${number} — how diagnostics and debug traces refer to this block`"
    v-if="number != null"
  >{{ number }}</div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";

/* The analyzer names blocks by their diagram key — 'block "4" references the whole form…' —
   but that key (drawflow's node id) is visible nowhere on the canvas, so a cited block could
   not be found by looking. A small corner tag on every block closes that gap.
   Resolved by matching data.id against the store diagram (the same lookup the debug path
   uses); the diagram is mutated outside Vue's reactivity, so re-resolve on the designer's
   refreshAutomationBlocks signal instead of computing. */
export default {
  props: {
    /* the block's node data — its nanoID is the join key to the diagram */
    data: Object,
  },
  data: () => ({ number: null }),
  methods: {
    resolve() {
      const diagram = automationDesignStore.state.diagram;
      const dataId = this.data && this.data.id;
      if (!diagram || !dataId) {
        this.number = null;
        return;
      }
      const key = Object.keys(diagram).find(
        k => diagram[k] && diagram[k].data && diagram[k].data.id == dataId
      );
      this.number = key != null ? key : null;
    },
  },
  created() {
    /* before first render, so the number never flashes in */
    this.resolve();
  },
  mounted() {
    window.eventBus.$on("refreshAutomationBlocks", this.resolve);
  },
  beforeDestroy() {
    window.eventBus.$off("refreshAutomationBlocks", this.resolve);
  },
};
</script>

<style lang="scss" scoped>
.fts-automation-block-number {
  position: absolute;
  top: -0.4375rem;
  left: -0.4375rem;
  min-width: 0.875rem;
  height: 0.875rem;
  padding: 0 0.1875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10em;
  background-color: var(--fts-card-background);
  box-shadow: var(--fts-elevation-2);
  color: var(--fts-default);
  font-size: 0.5625rem;
  font-weight: 600;
  line-height: 1;
}
</style>
